import React, {
  useEffect,
  // useState,
} from "react";
import styled from "styled-components";
import propertyImage from "../assets/images/propiedad.jpg";
import propertyImage2 from "../assets/images/propiedad-lujo.jpg";
import propertyImage3 from "../assets/images/condominios.jpg";
import propertyImage4 from "../assets/images/condominios-de-lujo.jpg";
import { Row, Col, Tabs, Popconfirm, Button } from "antd";
import { Margin, Padding } from "@devsplan/wealthclub-ui";
import { Link } from "react-router-dom";
import {
  BLUE_COLOR,
  DASHBOARD_ROUTE,
  // PRIMARY_COLOR,
} from "../shared/constants";
import { Image } from "../components/Image";
import logoHorizontal from "../assets/images/logo_wc.png";
import { useMedia } from "react-use";
import { LogoutOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import LangSwitcher from "../components/LangSwitcher";
// import logo from "../assets/images/logo-large.png";
import Footer from "../components/Footer";
import { useAuth } from "../providers/AuthProvider";
import { setBodyBg } from "../shared/utils";

const Card = styled.div`
  transition: all 0.25s ease;
  cursor: pointer;
  border-radius: 5px;
  background-color: #fff;
  min-height: 495px;

  &:hover {
    transform: scale(1.05);
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 2.5px 2.5px 0px 0px;
`;

const CardHeader = styled.div`
  background: linear-gradient(
    90deg,
    rgba(191, 149, 63, 1) 0%,
    rgba(251, 230, 149, 1) 50%,
    rgba(191, 149, 63, 1) 100%
  );
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.75);
  font-size: 18px;
  font-weight: bold;

  @media screen and (max-width: 1280px) {
    font-size: 16px;
  }
`;

const CardContent = styled.div`
  background-color: #fff;

  ul {
    margin: 0px;
    padding: 16px;
  }

  ul li {
    color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  @media screen and (max-width: 1280px) {
    ul li {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 768px) {
    ul li {
      font-size: 14px;
    }
  }
`;

export const CustomTabs = styled(Tabs)`
  position: relative;
  overflow: visible;

  .ant-tabs-tab-btn {
    color: #000 !important;
  }

  .ant-tabs-nav {
    margin: 0 !important;
  }

  .ant-tabs-tab {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .ant-tabs-tab-active {
    background-color: transparent !important;
  }
`;

const TopBar = styled.div`
  padding: 10px 50px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);

  p,
  span,
  div {
    color: #000 !important;
  }

  @media screen and (max-width: 768px) {
    padding: 10px 8px;
  }
`;

const Title = styled.h1`
  color: #000;
`;

// const SystemDiv = styled.div<{ active?: boolean }>`
//   width: 100%;
//   height: 350px;
//   margin-right: 50px;
//   position: relative;
//   border-radius: 15px;
//   transition: all 0.25s ease;
//   cursor: pointer;

//   &:hover {
//     transform: scale(1.05);
//     box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
//   }

//   ${(props) =>
//     props.active &&
//     `
//     border: 5px solid ${PRIMARY_COLOR};
//   `}
// `;

// const SystemImage = styled.img`
//   width: 100%;
//   height: 100%;
//   border-radius: 10px;
//   object-fit: cover;
//   max-width: 100%;
// `;

// const SystemLogo = styled.img`
//   width: 100px;
//   height: 100px;
//   max-width: 100%;
//   position: absolute;

//   @media screen and (max-width: 768px) {
//     width: 80px;
//     height: 80px;
//   }
// `;

// const SystemTitle = styled.h2`
//   position: absolute;
//   background: transparent
//     radial-gradient(
//       closest-side at 50% 50%,
//       #d6ab34 0%,
//       #f3bf32 52%,
//       #efdba4 100%
//     )
//     0% 0% no-repeat padding-box;
//   color: transparent;
//   -webkit-background-clip: text;
//   -webkit-text-stroke: 0.7px #000000;
//   opacity: 1;
//   font-family: "montserrat";
//   font-weight: 700;
//   font-size: 32px;

//   @media screen and (max-width: 768px) {
//     font-size: 24px;
//   }
// `;

// const SystemOpacity = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.3);
//   border-radius: 10px;
// `;

const RealStateView = () => {
  const { logout } = useAuth();
  const isTabletOrMobile = useMedia("(max-width: 1224px)");
  // const [activeSystem, setActiveSystem] = useState<"earnings" | "investments">(
  //   "earnings"
  // );
  const { t } = useTranslation();

  const properties = [
    {
      title: t("PROPERTY"),
      image: propertyImage,
      details: [
        {
          name: t("MINIMUM INVESTMENT"),
          value: "$10,000",
        },
        {
          name: t("MAXIMUM INVESTMENT"),
          value: "$100,000",
        },
        {
          name: t("DISTRIBUTION"),
          value: t("MONTHLY"),
        },
        {
          name: t("ESTIMATED CASH FLOW"),
          value: "1%-3%",
        },
        {
          name: t("ESTIMATED IRR"),
          value: "15%",
        },
        {
          name: t("TOTAL FUND"),
          value: "$250,000",
          bold: true,
        },
        {
          name: t("MINIMUM HOLDING"),
          value: `5 ${t("YEARS")}`,
          bold: true,
        },
      ],
    },
    {
      title: t("LUXURY PROPERTY"),
      image: propertyImage2,
      details: [
        {
          name: t("MINIMUM INVESTMENT"),
          value: "$20,000",
        },
        {
          name: t("MAXIMUM INVESTMENT"),
          value: "$1,000,000",
        },
        {
          name: t("DISTRIBUTION"),
          value: t("MONTHLY"),
        },
        {
          name: t("ESTIMATED CASH FLOW"),
          value: "2%-5%",
        },
        {
          name: t("ESTIMATED IRR"),
          value: "15%",
        },
        {
          name: t("TOTAL FUND"),
          value: "$1,000,000",
          bold: true,
        },
        {
          name: t("MINIMUM HOLDING"),
          value: `5 ${t("YEARS")}`,
          bold: true,
        },
      ],
    },
    {
      title: t("CONDOMINIUMS"),
      image: propertyImage3,
      details: [
        {
          name: t("MINIMUM INVESTMENT"),
          value: "$50,000",
        },
        {
          name: t("MAXIMUM INVESTMENT"),
          value: "$1,000,000",
        },
        {
          name: t("NUMBER OF UNITS"),
          value: `${t("UNTIL")} 20`,
        },
        {
          name: t("DISTRIBUTION"),
          value: t("MONTHLY"),
        },
        {
          name: t("ESTIMATED CASH FLOW"),
          value: "3%-5%",
        },
        {
          name: t("ESTIMATED IRR"),
          value: "15%",
        },
        {
          name: t("TOTAL FUND"),
          value: "$5,000,000",
          bold: true,
        },
        {
          name: t("MINIMUM HOLDING"),
          value: `5 ${t("YEARS")}`,
          bold: true,
        },
      ],
    },
    {
      title: t("LUXURY CONDOMINIUMS"),
      image: propertyImage4,
      details: [
        {
          name: t("MINIMUM INVESTMENT"),
          value: "$50,000",
        },
        {
          name: t("MAXIMUM INVESTMENT"),
          value: "$1,000,000",
        },
        {
          name: t("NUMBER OF UNITS"),
          value: `${t("MORE")} 20`,
        },
        {
          name: t("DISTRIBUTION"),
          value: t("MONTHLY"),
        },
        {
          name: t("ESTIMATED CASH FLOW"),
          value: "3%-7%",
        },
        {
          name: t("ESTIMATED IRR"),
          value: "15%",
        },
        {
          name: t("TOTAL FUND"),
          value: "$10,000,000",
          bold: true,
        },
        {
          name: t("MINIMUM HOLDING"),
          value: `5 ${t("YEARS")}`,
          bold: true,
        },
      ],
    },
  ];

  useEffect(() => {
    setBodyBg("realstate");
  }, []);

  return (
    <div>
      <TopBar>
        <Row justify="space-between" align="middle">
          <Col xs={12}>
            <Row align="middle">
              {!isTabletOrMobile && (
                <Link to={DASHBOARD_ROUTE}>
                  <Image width="45px" height="auto" src={logoHorizontal} />
                </Link>
              )}
              <Margin left="18px">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="117.058"
                  height="30.771"
                  viewBox="0 0 117.058 30.771"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.5"
                      x2="0.5"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#d6ab34" />
                      <stop offset="0.49" stop-color="#f0cb65" />
                      <stop offset="1" stop-color="#d6ab34" />
                    </linearGradient>
                    <linearGradient
                      id="linear-gradient-2"
                      x1="0.5"
                      x2="0.5"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#a7a7a7" />
                      <stop offset="1" stop-color="#e1e1e1" />
                    </linearGradient>
                  </defs>
                  <g
                    id="Group_34"
                    data-name="Group 34"
                    transform="translate(-639.577 -273.456)"
                  >
                    <g
                      id="Group_32"
                      data-name="Group 32"
                      transform="translate(1.177 38)"
                    >
                      <path
                        id="Intersection_2"
                        data-name="Intersection 2"
                        d="M-207.524-10059.311l1.044-2.319a7.808,7.808,0,0,0,4.39,1.389c1.823,0,2.564-.607,2.564-1.427,0-2.488-7.733-.778-7.733-5.717,0-2.264,1.823-4.143,5.606-4.143a8.91,8.91,0,0,1,4.615,1.179l-.948,2.336a7.526,7.526,0,0,0-3.687-1.044c-1.823,0-2.526.683-2.526,1.52,0,2.45,7.733.759,7.733,5.642,0,2.223-1.843,4.122-5.644,4.122A9.491,9.491,0,0,1-207.524-10059.311Zm49.685,1.31v-13.3h10.052v2.471h-6.992v2.888h6.175v2.393h-6.175v3.08h7.237v2.468Zm-8.987,0v-10.79h-4.256v-2.509h11.589v2.509h-4.256v10.79Zm-6.706,0-1.178-2.848h-6.175l-1.178,2.848h-3.153l5.927-13.3h3.04l5.948,13.3Zm-6.365-5.187h4.218l-2.109-5.093Zm-11.9,5.187v-10.79h-4.256v-2.509h11.589v2.509h-4.256v10.79Zm-31.541,0v-13.3h3.08v10.793h6.668v2.506Zm-4.615,0-1.178-2.848H-235.3l-1.178,2.848h-3.153l5.927-13.3h3.04l5.948,13.3Zm-6.365-5.187h4.218l-2.109-5.093Zm-16.323,5.187v-13.3h10.052v2.471h-6.992v2.888h6.175v2.393h-6.175v3.08h7.24v2.468Zm-5.49,0-2.564-3.705h-2.832v3.705H-264.6v-13.3h5.758c3.553,0,5.776,1.844,5.776,4.825a4.328,4.328,0,0,1-2.736,4.2l2.981,4.273Zm-5.4-6.155h2.509c1.881,0,2.83-.875,2.83-2.318,0-1.462-.948-2.316-2.83-2.316h-2.509Z"
                        transform="translate(903 10324)"
                        fill="url(#linear-gradient)"
                      />
                    </g>
                    <g
                      id="Group_33"
                      data-name="Group 33"
                      transform="translate(-0.616 20)"
                    >
                      <path
                        id="Intersection_1"
                        data-name="Intersection 1"
                        d="M-176.529-10096.7v-4.7h1.946v4.633c0,1.6.7,2.255,1.872,2.255s1.87-.659,1.87-2.255v-4.633h1.921v4.7a3.476,3.476,0,0,1-3.8,3.839A3.478,3.478,0,0,1-176.529-10096.7Zm-16.392-.5a4.317,4.317,0,0,1,4.562-4.343,4.331,4.331,0,0,1,3.455,1.489l-1.248,1.151a2.7,2.7,0,0,0-2.111-.984,2.577,2.577,0,0,0-2.689,2.687,2.577,2.577,0,0,0,2.689,2.689,2.668,2.668,0,0,0,2.111-1l1.248,1.152a4.31,4.31,0,0,1-3.468,1.5A4.314,4.314,0,0,1-192.92-10097.2ZM-167-10093v-8.4h4.1c2.1,0,3.179.875,3.179,2.185a2.017,2.017,0,0,1-1.116,1.847,2.074,2.074,0,0,1,1.537,2.075c0,1.454-1.152,2.293-3.362,2.293Zm1.933-1.464h2.266c1.01,0,1.55-.312,1.55-1.032s-.54-1.045-1.55-1.045h-2.266Zm0-3.493h1.931c.949,0,1.464-.335,1.464-.994s-.515-.984-1.464-.984h-1.931ZM-183.6-10093v-8.4h1.946v6.814h4.211v1.585Zm-16.128,0v-3.445h-3.816v3.445h-1.943v-8.4h1.943v3.311h3.816v-3.311h1.946v8.4Zm-11.434,0v-6.816h-2.689v-1.583h7.322v1.583h-2.689v6.816Zm-8.21,0v-8.4h1.946v6.814h4.211v1.585Zm-2.915,0-.743-1.8h-3.9l-.746,1.8h-1.992l3.745-8.4H-224l3.755,8.4Zm-4.019-3.277h2.664l-1.332-3.215Zm-10.308,3.277v-8.4h6.348v1.56h-4.417v1.824h3.9v1.513h-3.9v1.943h4.572v1.56Zm-5.916,0-1.849-5.687-1.908,5.688h-2.075l-2.76-8.4h2.017l1.9,5.9,1.979-5.9h1.8l1.921,5.951,1.956-5.951h1.86l-2.748,8.4Z"
                        transform="translate(903 10355)"
                        fill="url(#linear-gradient-2)"
                      />
                    </g>
                  </g>
                </svg>
              </Margin>
            </Row>
          </Col>
          <Col xs={12}>
            <Row justify="end" align="middle">
              <Margin left={isTabletOrMobile ? "16px" : "24px"}>
                <LangSwitcher />
              </Margin>
              <Popconfirm
                title={t("Are you sure to log out")}
                onConfirm={() => logout()}
                okText={t("Yes")}
                okButtonProps={{
                  style: { width: 50, color: BLUE_COLOR },
                }}
                cancelButtonProps={{ style: { width: 50 } }}
                cancelText={t("No")}
              >
                <Button
                  type="text"
                  style={{ marginLeft: isTabletOrMobile ? 4 : 8 }}
                >
                  <Row justify="center" align="middle">
                    <LogoutOutlined
                      style={{ fontSize: 24, marginRight: 8, color: "#000" }}
                    />
                    {isTabletOrMobile ? (
                      ""
                    ) : (
                      <span style={{ color: "#000" }}>{t("Sign off")}</span>
                    )}
                  </Row>
                </Button>
              </Popconfirm>
            </Row>
          </Col>
        </Row>
      </TopBar>
      <Row justify="center" align="middle">
        <Col xs={24} sm={24} md={24} lg={24} xl={22} xxl={18}>
          <Padding
            bottom="50px"
            left={isTabletOrMobile ? "8px" : "50px"}
            right={isTabletOrMobile ? "8px" : "50px"}
          >
            {/* <Row
              justify="space-between"
              align="middle"
              style={{ marginTop: 32 }}
              gutter={[32, 32]}
            >
              <Col xs={24} sm={24} md={12} lg={12}>
                <SystemDiv
                  active={activeSystem === "earnings"}
                  onClick={() => setActiveSystem("earnings")}
                >
                  <SystemOpacity />
                  <SystemTitle style={{ bottom: 24, left: 24 }}>
                    {t("PROGRAM OF")} <br /> {t("PASSIVE INCOME")}
                  </SystemTitle>
                  <SystemImage src={propertyImage} alt="Propert" />
                  <SystemLogo
                    src={logo}
                    id="logo"
                    style={{ left: 24, top: 24 }}
                  />
                </SystemDiv>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <SystemDiv
                  active={activeSystem === "investments"}
                  onClick={() => setActiveSystem("investments")}
                >
                  <SystemOpacity />
                  <SystemTitle style={{ top: 24, left: 24 }}>
                    {t("PROGRAM OF")} <br /> {t("INVESTMENTS")}
                  </SystemTitle>
                  <SystemImage src={propertyImage3} alt="Propert" />
                  <SystemLogo
                    src={logo}
                    id="logo"
                    style={{ right: 24, bottom: 24 }}
                  />
                </SystemDiv>
              </Col>
            </Row> */}
            <Margin top="32px">
              <CustomTabs size="large">
                <CustomTabs.TabPane tab={t("Offers")} key="0">
                  <Row
                    align="middle"
                    gutter={[16, 16]}
                    style={{ paddingTop: 32 }}
                  >
                    {properties.map((p, pIndex) => (
                      <Col xs={24} sm={24} md={12} lg={6} key={pIndex}>
                        <Card>
                          <CardImage src={p.image} />
                          <CardHeader>{p.title}</CardHeader>
                          <CardContent>
                            <ul>
                              {p.details.map((detail, detailIndex) => (
                                <li
                                  key={detailIndex}
                                  style={{
                                    fontWeight: detail.bold ? "bold" : "normal",
                                  }}
                                >
                                  <span>{detail.name}</span>
                                  <span>{detail.value}</span>
                                </li>
                              ))}
                            </ul>
                          </CardContent>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </CustomTabs.TabPane>
                <CustomTabs.TabPane tab={t("Transactions")} key="1">
                  <Margin top="32px">
                    <Row justify="center">
                      <Title>{t("No transactions")}</Title>
                    </Row>
                  </Margin>
                </CustomTabs.TabPane>
                <CustomTabs.TabPane tab={t("Investments")} key="2">
                  <Margin top="32px">
                    <Row justify="center">
                      <Title>{t("No investments")}</Title>
                    </Row>
                  </Margin>
                </CustomTabs.TabPane>
              </CustomTabs>
            </Margin>
          </Padding>
        </Col>
      </Row>
      <Footer />
    </div>
  );
};

export default RealStateView;
